var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicGenRx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_39145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9V4.5C5.625 3.60489 5.98058 2.74645 6.61351 2.11351C7.24645 1.48058 8.10489 1.125 9 1.125C9.89511 1.125 10.7536 1.48058 11.3865 2.11351C12.0194 2.74645 12.375 3.60489 12.375 4.5V9C12.375 9.89511 12.0194 10.7536 11.3865 11.3865C10.7536 12.0194 9.89511 12.375 9 12.375C8.10489 12.375 7.24645 12.0194 6.61351 11.3865C5.98058 10.7536 5.625 9.89511 5.625 9ZM14.625 9C14.625 8.85082 14.5657 8.70774 14.4602 8.60225C14.3548 8.49676 14.2117 8.4375 14.0625 8.4375C13.9133 8.4375 13.7702 8.49676 13.6648 8.60225C13.5593 8.70774 13.5 8.85082 13.5 9C13.5 10.1935 13.0259 11.3381 12.182 12.182C11.3381 13.0259 10.1935 13.5 9 13.5C7.80653 13.5 6.66193 13.0259 5.81802 12.182C4.97411 11.3381 4.5 10.1935 4.5 9C4.5 8.85082 4.44074 8.70774 4.33525 8.60225C4.22976 8.49676 4.08668 8.4375 3.9375 8.4375C3.78832 8.4375 3.64524 8.49676 3.53975 8.60225C3.43426 8.70774 3.375 8.85082 3.375 9C3.37671 10.394 3.89526 11.7378 4.83036 12.7716C5.76546 13.8054 7.05069 14.4558 8.4375 14.5969V16.875C8.4375 17.0242 8.49676 17.1673 8.60225 17.2727C8.70774 17.3782 8.85082 17.4375 9 17.4375C9.14918 17.4375 9.29226 17.3782 9.39775 17.2727C9.50324 17.1673 9.5625 17.0242 9.5625 16.875V14.5969C10.9493 14.4558 12.2345 13.8054 13.1696 12.7716C14.1047 11.7378 14.6233 10.394 14.625 9Z",
    fill: "#ED8A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_39145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicGenRx);
export default __webpack_public_path__ + "static/media/mic-gen-rx.223139722c882493273960f640125590.svg";
export { ForwardRef as ReactComponent };